export const ARTIFACT_CARD_HEIGHT_PX = 60;
export const ARTIFACT_SKELETON_CLASS = 'animate-pulse rounded-md bg-grayA-3';
export const PAPER_PAGE_WIDTH_PX = 668;
export const PAPER_PAGE_UNSCALED_CLASS =
  'absolute left-0 top-0 h-[900px] w-[668px] origin-top-left border-0';
